/* eslint-disable no-console */
const toggleSubnav = (selector, navToggle, menuToggle) => {
  if (selector === null) {
    return;
  }
  // Add hover state to selector
  selector.classList.toggle(navToggle);
  const subnav = selector.getAttribute('data-subnav');
  if (subnav === null || subnav === '') {
    return;
  }
  const menu = document.querySelector(subnav);
  if (menu !== null) {
    menu.classList.toggle(menuToggle);
  }
};

const hideSubnav = (selector, navToggle, menuToggle) => {
  if (selector === null) {
    return;
  }
  const subnav = selector.getAttribute('data-subnav');
  if (subnav === null || subnav === '') {
    return;
  }
  const menu = document.querySelector(subnav);
  if (menu !== null) {
    menu.classList.add(menuToggle);
  }
};

const toggleNavImage = (selector) => {
  if (selector === null) {
    return;
  }
  const navimg = selector.getAttribute('data-navimg');
  if (navimg === null || navimg === '') {
    return;
  }
  const img = document.querySelector(navimg);
  const src = selector.getAttribute('data-imgsrc');
  const label = selector.textContent;
  if (img !== null && src !== null) {
    img.src = src;
    img.alt = `Active dropdown nav item image preview for ${label}`;
    // object-fit fallback
    if ('objectFit' in document.documentElement.style === false) {
      if (img.src) {
        img.parentNode.setAttribute('style', `background-image:url(${encodeURI(img.src)});`);
        img.parentNode.classList.add('compat-object-fit');
      }
    }
  }
};

const getButton = (element) => {
  if (element === null) {
    return null;
  }
  if (element.tagName.toLowerCase() === 'button') {
    return element;
  }
  if (element.querySelector('button') !== null) {
    return element.querySelector('button');
  }
  return null;
};

const addListeners = (options) => {
  const {
    menuSelectors,
    navToggle,
    subnavToggle,
  } = options;
  // For accessibility
  [].map.call(document.querySelectorAll(`${menuSelectors} button`), menuItem => menuItem.addEventListener('click', () => {
    // Hide any content for "open" menuItems
    const navItems = menuItem.parentNode.parentNode.querySelectorAll('.nav--menu-item');
    for (let i = 0; i < navItems.length; i++) { /* eslint-disable-line no-plusplus */
      navItems[i].classList.remove(navToggle);
      hideSubnav(
        navItems[i],
        navToggle,
        subnavToggle,
      );
    }
    // Show current menuItem content
    toggleSubnav(
      menuItem.parentNode,
      navToggle,
      subnavToggle,
    );
    if (menuItem.getAttribute('aria-expanded') === 'true' && getButton()) {
      getButton().setAttribute('aria-expanded', 'false');
    } else if (menuItem.getAttribute('aria-expanded') === 'false' && getButton()) {
      getButton().setAttribute('aria-expanded', 'true');
    }
    toggleNavImage(menuItem.parentNode);
  }));
  // Add over to button wrappers
  [].map.call(document.querySelectorAll(`${menuSelectors} button`), menuItem => menuItem.parentNode.addEventListener('mouseenter', () => {
    // Hide any content for "open" menuItems
    const navItems = menuItem.parentNode.parentNode.querySelectorAll('.nav--menu-item');
    for (let i = 0; i < navItems.length; i++) { /* eslint-disable-line no-plusplus */
      navItems[i].classList.remove(navToggle);
      hideSubnav(
        navItems[i],
        navToggle,
        subnavToggle,
      );
    }
    // Show current menuItem content
    toggleSubnav(
      menuItem.parentNode,
      navToggle,
      subnavToggle,
    );
    // Fix for tab-role.js override
    const subnav = document.querySelector(menuItem.parentNode.getAttribute('data-subnav'));
    if (subnav) {
      subnav.parentNode.removeAttribute('hidden');
    }
    if (menuItem.getAttribute('aria-expanded') === 'true' && getButton()) {
      getButton().setAttribute('aria-expanded', 'false');
    } else if (menuItem.getAttribute('aria-expanded') === 'false' && getButton()) {
      getButton().setAttribute('aria-expanded', 'true');
    }
    toggleNavImage(menuItem.parentNode);
  }));
  [].map.call(document.querySelectorAll(`${menuSelectors} a`), menuItem => menuItem.addEventListener('mouseenter', () => {
    toggleNavImage(menuItem.parentNode);
  }));
};

const closeAllMenus = (options) => {
  const { mainMenuItem } = options;
  const mainMenuItems = document.querySelectorAll(mainMenuItem);
  // Set default content for each menu
  for (let i = 0; i < mainMenuItems.length; i++) { /* eslint-disable-line no-plusplus */
    mainMenuItems[i].classList.remove('is-active');
    if (mainMenuItems[i].querySelector('button') !== null) {
      mainMenuItems[i].querySelector('button').setAttribute('aria-expanded', 'false');
    }
  }
};

const init = (options) => {
  let menuCloseTimer = 0;
  const closeMenuOnBodyClick = (event) => {
    if (event.target.closest('.nav-list-item') === null) {
      closeAllMenus(options);
      document.querySelector('body').removeEventListener('click', closeMenuOnBodyClick);
    }
  };
  // Create image element in each menu
  const {
    defaultSelected,
    mainMenuItem,
    mainSubnav,
    menuImageSelector,
    menus,
    navToggle,
    subnavToggle,
  } = options;
  const imgWrappers = document.querySelectorAll(menus);
  // Set default content for each menu
  for (let i = 0; i < imgWrappers.length; i++) { /* eslint-disable-line no-plusplus */
    const img = document.createElement('IMG');
    img.scr = '';
    img.alt = '';
    imgWrappers[i].querySelector(menuImageSelector).appendChild(img);
    const defaultMenuItem = imgWrappers[i].querySelector(`${mainSubnav} ${defaultSelected}`);
    // console.log(defaultMenuItem);
    toggleNavImage(defaultMenuItem);
    toggleSubnav(
      defaultMenuItem,
      navToggle,
      subnavToggle,
    );
  }
  [].map.call(document.querySelectorAll(`${mainMenuItem} > button`), menuItem => menuItem.addEventListener('click', () => {
    if (menuItem.parentNode.classList.contains('is-active')) {
      menuItem.parentNode.classList.remove('is-active');
      menuItem.setAttribute('aria-expanded', 'false');
      document.querySelector('body').removeEventListener('click', closeMenuOnBodyClick);
    } else {
      closeAllMenus(options);
      menuItem.parentNode.classList.add('is-active');
      menuItem.setAttribute('aria-expanded', 'true');
      document.querySelector('body').addEventListener('click', closeMenuOnBodyClick);
    }
  }));
  [].map.call(document.querySelectorAll(`${mainMenuItem} > button`), menuItem => menuItem.parentNode.addEventListener('mouseenter', () => {
    clearTimeout(menuCloseTimer);
    closeAllMenus(options);
    menuItem.parentNode.classList.add('is-active');
    menuItem.setAttribute('aria-expanded', 'true');
    document.querySelector('body').addEventListener('click', closeMenuOnBodyClick);
  }));
  [].map.call(document.querySelectorAll(`${mainMenuItem} > button`), menuItem => menuItem.parentNode.addEventListener('mouseleave', () => {
    menuCloseTimer = setTimeout(() => {
      menuItem.parentNode.classList.remove('is-active');
      menuItem.setAttribute('aria-expanded', 'false');
      document.querySelector('body').removeEventListener('click', closeMenuOnBodyClick);
    }, 750);
  }));
  addListeners(options);
};

export default {
  init,
};
/* eslint-enable no-console */
